export default __webpack_public_path__ + "static/media/hulk-NB.21b1f045.png";